import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'
import { ViewStyle } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import { orLabel } from '@lyrahealth-inc/shared-app-logic'

import { BodyTextSize } from '../../styles/typeStyles'
import { ThemeType, tID } from '../../utils'
import { BodyText } from '../bodyText/BodyText'

export interface OrDividerProps {
  text?: string | React.ReactNode
  textSize?: BodyTextSize
  textBold?: boolean
  marginVertical?: number
  textPaddingHorizontal?: number
  textColor?: string
  lineColor?: string
  lineHeight?: number
  style?: ViewStyle
  testID?: string
}

const DividerContainer = styled.View<{
  theme: ThemeType
  marginVertical: number
}>(({ theme, marginVertical }) => ({
  marginVertical: marginVertical !== undefined ? `${marginVertical}px` : theme.spacing['24px'],
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

const DividerText = styled(BodyText)<{
  theme: ThemeType
  textPaddingHorizontal: number
  textColor: string
}>(({ theme, textPaddingHorizontal, textColor }) => ({
  marginHorizontal: textPaddingHorizontal !== undefined ? `${textPaddingHorizontal}px` : theme.spacing['24px'],
  color: textColor,
}))

const DividerLine = styled.View<{
  lineColor: string
  lineHeight: number
}>(({ lineColor, lineHeight }) => ({
  flex: 1,
  height: lineHeight,
  backgroundColor: lineColor,
}))

export const OrDivider: FunctionComponent<OrDividerProps> = ({
  text,
  textSize = BodyTextSize.SMALL,
  textBold = false,
  marginVertical = 24,
  textPaddingHorizontal = 24,
  textColor,
  lineColor,
  lineHeight = 1,
  style,
  testID = 'OrDivider',
}) => {
  const { colors } = useTheme()
  const { formatMessage } = useIntl()

  const defaultText = formatMessage(orLabel.LOWERCASE)
  const displayText = text ?? defaultText

  const finalTextColor = textColor ?? colors.textSecondary
  const finalLineColor = lineColor ?? colors.dividerSecondary

  return (
    <DividerContainer marginVertical={marginVertical} style={style} testID={tID(testID)}>
      <DividerLine lineColor={finalLineColor} lineHeight={lineHeight} />
      <DividerText
        text={displayText}
        size={textSize}
        bold={textBold}
        textPaddingHorizontal={textPaddingHorizontal}
        textColor={finalTextColor}
      />
      <DividerLine lineColor={finalLineColor} lineHeight={lineHeight} />
    </DividerContainer>
  )
}
